import { ProcessOperationType } from 'types/Process';
import { CAPITAL_CALL_CONFIG } from './CAPITAL_CALL';
import { DEVOLUCION_INTERESES_CONFIG } from './DEVOLUCION_INTERESES';
import { DISMINUCION_CAPITAL_CDI_CONFIG } from './DISMINUCION_CAPITAL_CDI';
import { DISMINUCION_CAPITAL_SIN_CDI_CONFIG } from './DISMINUCION_CAPITAL_SIN_CDI';
import { REPARTO_CAPITAL_CONFIG } from './REPARTO_CAPITAL';
import { REPARTO_DIVIDENDO_CONFIG } from './REPARTO_DIVIDENDO';
import { ProcessExcelConfig } from './types';

const CONFIGS: Record<string, ProcessExcelConfig> = {
  [ProcessOperationType.CAPITAL_CALL]: CAPITAL_CALL_CONFIG,
  [ProcessOperationType.DEVOLUCION_INTERESES]: DEVOLUCION_INTERESES_CONFIG,
  [ProcessOperationType.REPARTO_CAPITAL]: REPARTO_CAPITAL_CONFIG,
  [ProcessOperationType.REPARTO_DIVIDENDO]: REPARTO_DIVIDENDO_CONFIG,
  [ProcessOperationType.DISMINUCION_CAPITAL_CDI]: DISMINUCION_CAPITAL_CDI_CONFIG,
  [ProcessOperationType.DISMINUCION_CAPITAL_SIN_CDI]: DISMINUCION_CAPITAL_SIN_CDI_CONFIG,
};

/** Tipos de operación con Excel configurado (plantilla y payload) */
export const SUPPORTED_OPERATION_TYPES_FOR_EXCEL: ProcessOperationType[] = [
  ProcessOperationType.CAPITAL_CALL,
  ProcessOperationType.DEVOLUCION_INTERESES,
  ProcessOperationType.REPARTO_CAPITAL,
  ProcessOperationType.REPARTO_DIVIDENDO,
  ProcessOperationType.DISMINUCION_CAPITAL_CDI,
  ProcessOperationType.DISMINUCION_CAPITAL_SIN_CDI,
];

export function getProcessExcelConfig(
  operationType: string,
): ProcessExcelConfig | undefined {
  return CONFIGS[operationType];
}

export { CAPITAL_CALL_CONFIG } from './CAPITAL_CALL';
export { DEVOLUCION_INTERESES_CONFIG } from './DEVOLUCION_INTERESES';
export { DISMINUCION_CAPITAL_CDI_CONFIG } from './DISMINUCION_CAPITAL_CDI';
export { DISMINUCION_CAPITAL_SIN_CDI_CONFIG } from './DISMINUCION_CAPITAL_SIN_CDI';
export { REPARTO_CAPITAL_CONFIG } from './REPARTO_CAPITAL';
export { REPARTO_DIVIDENDO_CONFIG } from './REPARTO_DIVIDENDO';
export type { ProcessExcelConfig, ColumnDef, ColType } from './types';
